<template>
  <div>
    <van-grid :column-num="1" clickable :center="false">
      <van-grid-item v-for="mi in list" :key="mi.ItemName" @click="cmdMI(mi)">
        <van-row>
          <van-col span="18">
            <!-- {{ mi }} -->
            <div class="fx12">{{ mi.DispName }}</div>
            <div class="van-multi-ellipsis--l2 remark" v-html="gGetIcon(mi.Remark)" />
            <div class="fx12 C1" v-if="!soldOut(mi)">{{ getPrice(mi) }}</div>
            <van-tag v-if="soldOut(mi)" round type="primary" size="large" color="#999"
              >售完</van-tag
            >
            <div v-if="gGetDcText(mi)">
              <span class="tag">{{ gGetDcText(mi) }}</span>
            </div>
          </van-col>
          <van-col span="6">
            <!-- {{ getItemQty(mi) }} -->

            <ImgItem :src="mi.ImgFile" :qty="getItemQty(mi)" />
          </van-col>
        </van-row>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<style scoped>
.van-image {
  width: 6rem;
  height: 6rem;
  border-radius: 3rem;
}
.remark {
  color: grey;
  margin: 0.3rem 0 0.3rem 0;
}
</style>

<script>
import ImgItem from "./ImgItem.vue";
export default {
  components: {
    ImgItem,
  },
  props: {
    bkmenu: Object,
    ordertmp: Array,
    list: Array,
  },
  data() {
    return {};
  },
  methods: {
    soldOut(item) {
      var find = this.sStopSale.find((r) => r.ItemName == item.ItemName);
      if (find) {
        return true;
      }
      return false;
    },
    getPrice(pItem) {
      let price = Number(pItem.Price1);
      if (this.sGetConfig("chkCarHide0Price") && price == 0) return "";
      return "$" + price;
    },
    getItemQty(item) {
      const ordertmp = this.$store.state.sOrdertmp;
      if (ordertmp == undefined) return 0;
      var array = ordertmp.filter(
        (r) => r.TypeNo == item.TypeNo && r.ItemName == item.ItemName
      );
      return this.gSum(array, "Qty");
    },
    cmdMI(obj) {
      var find = this.sStopSale.find((r) => r.ItemName == obj.ItemName);
      if (find) {
        return this.gMsgbox("此項目已售完");
      }

      this.$emit("click", obj);
    },
  },
};
</script>
